import React, { useEffect } from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import useLocalStorage from '@rehooks/local-storage'
import { useDispatch } from 'react-redux'
import { setLogin } from '../../redux/slices/utils/userSlice'
import { LoginStyledContainer } from './Styled'
import { useLocation } from 'react-router-dom'
import { themeColor } from 'src/utils/themeData'
import CustomButton from '../../components/Button'

const Login = () => {
  const dispatch = useDispatch()
  const [, setType] = useLocalStorage('type')
  const [previousPath] = useLocalStorage('previousPath')
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const param = searchParams.get('previousPath')
  const userType = searchParams.get('user-type')
  const isAutoLogin =
    userType && ['Agent', 'Staff', 'Prospect'].includes(userType)

  useEffect(() => {
    if (param) {
      window.localStorage.setItem('previousPath', `${param}`)
    } else {
      if (!previousPath || previousPath === '/') {
        window.localStorage.setItem('previousPath', `/dms/`)
      }
    }
  }, [param])

  useEffect(() => {
    if (isAutoLogin) {
      saveCurrentRealm(userType)
    }
  }, [userType])

  const saveCurrentRealm = (type) => {
    dispatch(setLogin())
    setType(type)
    setTimeout(() => {
      location.href = '/logging-in'
    }, 100)
  }

  if (isAutoLogin) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: '#FFFFFF',
          zIndex: '99999',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress size={30} />
        <Typography sx={{ mt: 2 }}>กรุณารอสักครู่</Typography>
      </Box>
    )
  }

  return (
    <>
      <LoginStyledContainer>
        <Box
          display={{ xs: 'inline-block', sm: 'flex' }}
          gap={4}
          sx={{
            width: { xs: '100%', sm: 'auto' },
          }}
          justifyContent={'space-between'}
        >
          <Box
            display={'flex'}
            alignItems="center"
            justifyContent={'normal'}
            sx={{
              backgroundImage:
                'linear-gradient(to bottom right, #4B4DEB 0%, #9FBEAF 100%)',
              color: '#FFFFFF',
              width: '100%',
              p: { xs: 1, sm: 3 },
              minHeight: { xs: '50vh', sm: 'calc(110vh - 160px)' },
            }}
          >
            <Box sx={{ width: '100%' }} textAlign={'center'}>
              <Box
                sx={{
                  backgroundColor: themeColor.primary.secondary,
                  height: { xs: '75px', sm: '100px' },
                  width: { xs: '75px', sm: '100px' },
                  p: 2,
                  borderRadius: '50%',
                  margin: 'auto',
                  mb: 2,
                  pt: 2.5,
                }}
              >
                <img
                  alt={'AMS'}
                  width={'100%'}
                  src={`/image/home/step/2/done.svg`}
                />
              </Box>

              <Typography variant="h4" sx={{ width: 'auto' }}>
                เข้าสู่ระบบแบบผู้สมัครใหม่
              </Typography>
              <Typography sx={{ pt: 1, pb: 2, height: '60px' }} variant="body1">
                สำหรับผู้สมัครที่ประสงค์เป็นตัวแทนบริษัทกรุงไทย-แอกซ่า
                ประกันชีวิต
              </Typography>
              <CustomButton
                data-testid={'btn-login-prospect'}
                variant="contained"
                sx={{ width: '100%', maxWidth: '250px' }}
                onClick={() => saveCurrentRealm('Prospect')}
                size="large"
              >
                เข้าสู่ระบบแบบผู้สมัครใหม่
              </CustomButton>
              <Box height={{ xs: '0', sm: '110px' }}></Box>
            </Box>
          </Box>
          <Box
            display={'flex'}
            alignItems="center"
            sx={{
              width: '100%',
              p: 3,
              minHeight: { xs: '50vh', sm: 'calc(110vh - 200px)' },
            }}
          >
            <Box sx={{ width: '100%' }} textAlign={'center'}>
              <Box
                sx={{
                  backgroundColor: themeColor.primary.secondary,
                  height: { xs: '75px', sm: '100px' },
                  width: { xs: '75px', sm: '100px' },
                  p: 2,
                  borderRadius: '50%',
                  margin: 'auto',
                  mb: 2,
                  pt: 2.5,
                }}
              >
                <img
                  alt={'AMS'}
                  width={'100%'}
                  src={`/image/home/step/5/done.svg`}
                />
              </Box>
              <Typography
                color={'primary.secondary'}
                variant="h4"
                sx={{ display: 'inline-block', whiteSpace: 'nowrap' }}
              >
                เข้าสู่ระบบแบบตัวแทน/นายหน้า
              </Typography>
              <Typography sx={{ pt: 1, pb: 2, height: '60px' }} variant="body1">
                สำหรับตัวแทน/นายหน้าบริษัทกรุงไทย แอกซ่า ประกันชีวิต
              </Typography>
              <CustomButton
                data-testid={'btn-login-ma'}
                variant="contained"
                sx={{ width: '100%', maxWidth: '250px' }}
                onClick={() => saveCurrentRealm('Agent')}
                size="large"
              >
                เข้าสู่ระบบแบบตัวแทน/นายหน้า
              </CustomButton>
              <Box sx={{ maxWidth: '400px', m: 'auto' }}>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  my={4}
                  color="grey.300"
                >
                  <Box flex={1} height="1px" bgcolor="currentColor" />
                  <Typography variant="body1">หรือ</Typography>
                  <Box flex={1} height="1px" bgcolor="currentColor" />
                </Box>
              </Box>
              <Box>
                <Link
                  variant="body1"
                  color="primary.main"
                  onClick={() => saveCurrentRealm('Staff')}
                  sx={{ cursor: 'pointer' }}
                >
                  เข้าสู่ระบบ STAFF
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </LoginStyledContainer>
    </>
  )
}

Login.templateLayout = 'login'

export default Login
